import React, { createContext, useState, useEffect, useContext } from 'react';

import { useQueryDict } from 'hooks/app';
import { useMember } from 'hooks/member';
import { getCalendar, getReminder } from 'services/reminder-service';


const CalendarContext = createContext({});

export const CalendarProvider = ({ children }) => {
  const { queryDict } = useQueryDict();
  const { isLoggedIn, isSoftLoggedIn } = useMember();
  const [calendar, setCalendar] = useState();
  const [reminder, setReminder] = useState();
  const [initialized, setInitialized] = useState(!(queryDict.calendar_id || queryDict.r));

  useEffect(() => {
    if (isLoggedIn || isSoftLoggedIn) {
      if (queryDict.calendar_id) {
        setInitialized(false);
        getCalendarData();
      } else if (queryDict.r) {
        setInitialized(false);
        getReminderData();
      }
    }
  }, [queryDict.r, queryDict.calendar_id, isLoggedIn, isSoftLoggedIn]);

  const getCalendarData = async () => {
    const { errors, ...result } = await getCalendar({ ...queryDict, calendarId: queryDict.calendar_id });
    if (errors?.length > 0) {
      //
    } else {
      setCalendar(result);
    }
    setInitialized(true);
  }

  const getReminderData = async () => {
    const { errors, ...result } = await getReminder(queryDict);
    if (errors?.length > 0) {
      //
    } else {
      setReminder(result);
    }
    setInitialized(true);
  }

  const calendarName = calendar?.calendarName || calendar?.firstName || reminder?.reminderName;
  const calendarDttm = calendar?.calendarDttm || reminder?.calendarDttm;
  const calendarDate = calendar?.calendarDate || reminder?.reminderDate;
  const calendarTypeId = calendar?.calendarTypeId || reminder?.calendarTypeId;
  const cardSendId = calendar?.cardSendId || reminder?.cardSendId;
  const contact = calendar?.contact ?? reminder?.contact;
  const calendarId = calendar?.calendarId || reminder?.calendarId;
  let topic;
  if (initialized) {
    topic = calendarName && calendarTypeId !== 3 ? `For ${calendarName}` : 'Suggestions';
  }

  return (
    <CalendarContext.Provider value={{ calendarName, calendarDttm, calendarDate, calendarTypeId, cardSendId, calendarId, topic, contact, initialized }}>
      {children}
    </CalendarContext.Provider>
  );
}

export const useCalendar = () => useContext(CalendarContext);